import React from 'react';
import { observer, inject } from 'mobx-react';
import Util from 'utils';
import Request from 'utils/request';
import Config from 'config/Config';
import Stores from 'config/Stores';
import { wechatLogin } from 'utils/wxUtils';
import { Toast, Modal } from 'antd-mobile';
import { isWeChatMiniProgram } from 'utils/wxUtils';

const toWechatTipList = [
  '/promote/businessCard', // 我的名片页面
  '/learn/course/detail', // 课程详情页
  'share/reconstitu/transit' // 复消专区打卡分享中转页
];

const backHref = (Component) =>
  class extends React.Component {
    constructor(props) {
      super(props);
      this.props.AppMod = Stores.AppMod;
    }

    componentDidMount() {
      if (!this.props.AppMod.token) {
        localStorage.setItem('decoratorBackHref', window.location.href);
        window.app.routerGoTo('/login');
      }
    }

    render() {
      return <Component />;
    }
  };

// 静默登陆
const silentLogin = (Component) =>
  // eslint-disable-next-line react/no-multi-comp
  class extends React.Component {
    constructor(props) {
      super(props);
      this.props.AppMod = Stores.AppMod;
      this.props.LoginMod = Stores.LoginMod;
      this.state = {
        showContent: !(Util.isWeiXin() || Util.isXM()) // 微信，享脉
      };
    }

    componentDidMount() {
      const code = Util.getParamsQueryString(document.location.href, 'code');
      const state = Util.getParamsQueryString(document.location.href, 'state');
      const token = Util.getParamsQueryString(document.location.href, 'token');
      const time = Util.getParamsQueryString(document.location.href, 'time');
      const appId =
        Util.getParamsQueryString(document.location.href, 'appid') ||
        Util.getParamsQueryString(document.location.href, 'appId');
      const sign = Util.getParamsQueryString(document.location.href, 'sign');
      console.log('来源', { href: window.location.href, token, time, appId, sign });
      if (!!appId) {
        // 记录来源APPID
        Util.setLocalCache('member_appId', appId || '');
      }
      if (isWeChatMiniProgram) {
        if (token) {
          localStorage.setItem('member_token', JSON.stringify(token));
        }
      }
      if (!Util.isWeChat()) {
        // 非小程序内判断
        if (!!Util.getLocalCache('member_appId') || sessionStorage.getItem('systemCode') == 'XBL') {
          Util.setLocalCache('member_appId', ''); // 清除缓存
        }
      }
      if (token && time && appId && sign) {
        // console.log('免登录', this.props.AppMod.checkFreeLogin());
        // 免登录流程
        this.setState({ showContent: true });
        if (!this.props.AppMod.checkFreeLogin()) {
          // 校验失败
          window.app.routerGoTo('/login');
        }
      } else if (
        !this.props.AppMod.token &&
        !this.props.noLoginAuto &&
        !(window.location.href.indexOf('hideWechatAuthModal') != -1)
      ) {
        if (code && state) {
          // 微信静默登录回来
          this.setState({ showContent: true });
        } else if (code && Util.isXM()) {
          // 微信静默登录回来-享脉
          this.setState({ showContent: true });
        } else {
          // 去静默登录
          this.handleWechat();
        }
      } else {
        this.setState({ showContent: true });
      }
    }

    handleWechat = () => {
      if (Util.isWeiXin() || Util.isXM()) {
        const route = window.location.href.split('#') || [];

        Util.setLocalCache(Config.localStorageKeys.loginGoback, true);
        Util.setLocalCache(Config.localStorageKeys.registerRoute, route[1] || '');
        if (this.props.isEntry) sessionStorage.setItem('isEntryLogin', '1');
        // alert('启动1')

        this.handleWeChatLogin();
      } else if (!this.props.isEntry) {
        console.log('启动H5，测试');
        localStorage.setItem('decoratorBackHref', window.location.href);
        window.app.routerGoTo('/login');
      }
    };

    /**
     * 处理不同的授权场景
     *  1、微信静默授权后未绑卡回到来时的页面，已绑卡登录上并回到来时的页面
     *  2、微信静默授权后未绑定跳转到引导绑定页面，绑定了跳转回来时的页面
     *    2.1-引导绑定页面返回回到首页，去绑定绑定成功回到来时的页面
     *  3、企微静默授权查找未绑定再去获取敏感信息授权
     *    3.1-敏感授权同意用户手机号只有一张中台卡号，直接绑定企微并登录成功回到来时的页面
     *    3.2-敏感授权同意用户手机号有多张中台卡号，跳转到一号多卡选卡页面
     *    3.3-敏感授权同意用户手机号没有中台的卡号，跳转到引导绑定页面
     *    3.4-敏感授权用户点击拒绝或者返回，跳转到引导绑定页面
     *  4、享脉静默登录
     * 目前微信环境下大部分场景应该为1，跳转到wechatBaseLoginAuthView
     * 使用2场景的页面建立路由数组，识别到需要使用2场景的页面跳转wechatBackLoginAuthView(如我的名片页面)
     *
     */
    handleWeChatLogin = () => {
      const toWechatTip = toWechatTipList.some((route) => {
        const hash = window.location.hash;
        return hash.includes(route);
      });

      if (this.props.AppMod.workWechatAgentId) {
        // 企微下,场景3
        Request({
          url: `https://image.yofogo.com/config/appId.json`,
          host: Config.HOST_JSON,
          method: 'get',
          withCredentials: false,
          ignoreErr: true
        }).then((workWechatAppIdMap) => {
          const agentId = Stores.AppMod.workWechatAgentId;
          const appId = workWechatAppIdMap[agentId] || Config.wwAppId;
          const redirectUrl = encodeURIComponent(
            `${window.location.origin}${window.location.pathname}#/WorkPrivateAuth`
          );
          const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_privateinfo&agentid=${Stores.AppMod.workWechatAgentId}#wechat_redirect`;
          window.location.replace(url);
        });
      } else if (Util.isXM()) {
        // 场景4
        this.props.AppMod.jumpXMLogin();
      } else if (toWechatTip) {
        // 场景2
        // 标志引导绑定页面，点击返回按钮回到首页
        Util.setLocalCache(Config.localStorageKeys.wechatTipBackHome, true);
        const redirectUrl = encodeURIComponent(
          `${window.location.origin}${window.location.pathname}#/WechatBackLoginAuth`
        );
        window.location.replace(
          `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
            Config.wxAppId
          }&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base#wechat_redirect`
        );
      } else {
        // 场景1
        this.props.AppMod.jumpWeChatLogin('snsapi_base');
      }
    };

    render() {
      return this.state.showContent ? <Component /> : <div>{}</div>;
    }
  };

export { backHref, silentLogin };



// WEBPACK FOOTER //
// ./src/utils/decorator.js